"use strict";
exports.__esModule = true;
exports.processErrors = exports.isErrors = void 0;
exports.isErrors = function (input) { return !!input.errorsField; };
exports.processErrors = function (errorResult) {
    if ('data' in errorResult) {
        if (exports.isErrors(errorResult.data)) {
            return errorResult.data;
        }
        return { errorsField: errorResult.data };
    }
    if ('errors' in errorResult) {
        if (exports.isErrors(errorResult.errors)) {
            return errorResult.errors;
        }
        return { errorsField: errorResult.errors };
    }
    return errorResult;
};
